export const JsonTypeEnum = {
  String: "string",
  Number: "number",
  Boolean: "boolean",
  Array: "array",
  Object: "object",
  Date: "date",
} as const;

export type TJsonTypeEnumKeys = keyof typeof JsonTypeEnum;
export type TJsonTypeEnumValues = (typeof JsonTypeEnum)[TJsonTypeEnumKeys];
